<div class="coming-soon">
  <app-icon name="cog"></app-icon>
  <h1 translate>coming_soon</h1>
</div>
